export default __webpack_public_path__ + "static/media/productmenuicon.0f40463a.svg";